import React, { useEffect, useState } from "react";
import FsLightbox from "fslightbox-react";

const ImageBox = ({toggler,slide,images}) => {

  const imgs = images.map(url => (
    <img src={url}/>
  ));
  return (
    <>
     
    <FsLightbox
        toggler={toggler}
        sources={imgs}
        slide={slide+1}
    />
</>
  )
}

export default ImageBox


	